<template>
    <div class="main">
      <news-list :url="url" :localBrand="localBrand" v-on:brandHover="brandFromChild"></news-list>
    </div>
</template>

<script>
  import newsList from './newsLists/newsList.vue'

  export default {
    name: "industryNews",
    data() {
      return {
        sortLength: '',
        url: 'news',
        showBrand: true,
        showTool: true,
        localBrand: '',
        localTool: ''
      }
    },
    components: {newsList},
    created: function () {
      sessionStorage.removeItem('tutorialHover');
    },
    methods: {
      brandFromChild(data){
        this.localBrand=data;
        // console.log(this.localBrand);
      }
    }
  }
</script>

<style scoped>
  .main {
    width: 1170px;
    margin: auto auto 15px auto;
    min-height: calc(100% - 486px);
  }


  @media screen and (max-width: 1024px) {
    .main {
      width: 100%;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/industryNews.vue